<template>
  <div class="content overseasTrendInformationInfo" id="content">
    <div class="posi">
      当前位置： 海外来风 &nbsp;>>&nbsp; 资讯中心 &nbsp;>>&nbsp;
      <span>资讯详情</span>
    </div>
    <p class="reviewTitle">{{ title }}</p>
    <p class="reviewTime">{{ time }}</p>
    <p v-html="content"></p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      time: "",
      content: "",
    };
  },
  mounted() {
    let informationId = this.$route.query.id;
    if (informationId) {
      this.informationDetail(informationId);
    }
  },
  methods: {
    informationDetail(id) {
      this.$http
        .get(`/api/admin/infomation/${id}`)
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            this.title = data.title;
            this.content = decodeURIComponent(data.content).replace(
              /<img/g,
              "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;' "
            ); // 解码
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style lang="scss" scoped>
.overseasTrendInformationInfo {
  .reviewTitle {
    font-size: 24px;
    text-align: center;
    margin: 55px 0 13px 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .reviewTime {
    font-size: 14px;
    text-align: center;
    padding-bottom: 26px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 53px;
  }
}
</style>